import React, { ReactNode, useState } from "react";

interface IRenderOnceProps {
  when: boolean;
  children: ReactNode;
}

function RenderOnce({
  when,
  children,
}: IRenderOnceProps): React.JSX.Element | null {
  const [hasRendered, setHasRendered] = useState(false);

  if (when && !hasRendered) {
    setHasRendered(true);
  }

  return hasRendered ? <>{children}</> : null;
}

export default RenderOnce;
